import {combineReducers, createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiHost} from "../apiData";
import {getLanguage} from "../locales/langUtils";
import {parseOrReject} from "../utils/utils";

export const getUsersActivity = createAsyncThunk(
    'getUsersActivity/getUsersActivity',
    async (_, {rejectWithValue}) => {
        const response = await fetch(`${apiHost}/api/admin/users/activity`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': getLanguage()
            },
            credentials: 'include'
        });

        return await parseOrReject(response, rejectWithValue);
    }
);

export const getUsersActivitySlice = createSlice({
    name: 'getPopularItemsStats',
    initialState: {
        isLoading: false,
        data: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsersActivity.pending, state => {
                state.isLoading = true;
            })
            .addCase(getUsersActivity.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getUsersActivity.rejected, (state) => {
                state.isLoading = false;
            })
    }
});

export const getPopularItemsStats = createAsyncThunk(
    'getPopularItemsStats/getPopularItemsStats',
    async (credentials, {rejectWithValue}) => {
        const period = credentials.period;
        const params = credentials.params;
        const response = await fetch(`${apiHost}/api/stats/dashboard/${period}/menu-item-views`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': getLanguage()
            },
            body: JSON.stringify({
                menuId: params.menu?.value,
                year: params.year?.value,
                month: params.month?.value,
                week: params.week?.value,
                day: params?.day
            }),
            credentials: 'include'
        });

        return await parseOrReject(response, rejectWithValue);
    }
);

export const getPopularItemsStatsSlice = createSlice({
    name: 'getPopularItemsStats',
    initialState: {
        isLoading: false,
        data: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPopularItemsStats.pending, state => {
                state.isLoading = true;
            })
            .addCase(getPopularItemsStats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getPopularItemsStats.rejected, (state) => {
                state.isLoading = false;
            })
    }
});

export const getScanStats = createAsyncThunk(
    'getScanStats/getScanStats',
    async ({period, data}, {rejectWithValue}) => {
        const response = await fetch(`${apiHost}/api/stats/dashboard/${period}/scans`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': getLanguage()
            },
            body: JSON.stringify({
                year: data.year?.value,
                month: data.month?.value,
                week: data.week?.value,
                day: data?.day
            }),
            credentials: 'include'
        });

        return await parseOrReject(response, rejectWithValue);
    }
);

export const getScanStatsSlice = createSlice({
    name: 'getScanStats',
    initialState: {
        isLoading: false,
        data: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(getScanStats.pending, state => {
                state.isLoading = true;
            })
            .addCase(getScanStats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getScanStats.rejected, (state) => {
                state.isLoading = false;
            })
    }
});

export const statisticsSlice = createSlice(
    {
        name: 'view',
        initialState: {
            period: null,
            chosenYear: null,
            chosenMonth: null,
            chosenWeek: null,
            chosenDay: null,
            chosenMenu: null
        },
        reducers: {
            setPeriod: (state, action) => {
                state.period = action.payload;
            },
            setChosenYear: (state, action) => {
                state.chosenYear = action.payload;
            },
            setChosenMonth: (state, action) => {
                state.chosenMonth = action.payload;
            },
            setChosenWeek: (state, action) => {
                state.chosenWeek = action.payload;
            },
            setChosenDay: (state, action) => {
                state.chosenDay = action.payload;
            },
            setPeriodData: (state, action) => {
                state.initialYear = action.payload?.initialYear;
                state.initialMonth = action.payload?.initialYear;
                state.initialWeek = action.payload?.initialYear;
                state.period = action.payload?.period;
                state.chosenMonth = action.payload?.chosenMonth;
                state.chosenYear = action.payload?.chosenYear;
                state.chosenDay = action.payload?.chosenDay;
            },
            setChosenMenu: (state, action) => {
                state.chosenMenu = action.payload;
            }
        }
    });

export const {
    setPeriod,
    setChosenYear,
    setChosenMonth,
    setChosenWeek,
    setChosenDay,
    setPeriodData,
    setChosenMenu
} = statisticsSlice.actions;

const statisticsReducer = combineReducers({
    view: statisticsSlice.reducer,
    scanStats: getScanStatsSlice.reducer,
    popularItemsStats: getPopularItemsStatsSlice.reducer,
    usersActivity: getUsersActivitySlice.reducer
});

export default statisticsReducer;